var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewCarePlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2396 14.6663V9.33301C28.2396 6.53275 28.2396 5.13261 27.6946 4.06306C27.2152 3.12224 26.4503 2.35734 25.5095 1.87798C24.44 1.33301 23.0398 1.33301 20.2396 1.33301H9.57291C6.77264 1.33301 5.37251 1.33301 4.30295 1.87798C3.36214 2.35734 2.59724 3.12224 2.11787 4.06306C1.57291 5.13261 1.57291 6.53275 1.57291 9.33301V26.6663C1.57291 29.4666 1.57291 30.8667 2.11787 31.9363C2.59724 32.8771 3.36214 33.642 4.30295 34.1214C5.37251 34.6663 6.77264 34.6663 9.57291 34.6663H14.9062M15.7396 16.333H8.23957M9.90624 22.9997H8.23957M21.5729 9.66634H8.23957M23.235 22.7173C21.9021 21.2023 19.6794 20.7948 18.0094 22.1821C16.3393 23.5694 16.1042 25.8888 17.4157 27.5296C18.7272 29.1703 23.235 32.9997 23.235 32.9997C23.235 32.9997 27.7428 29.1703 29.0543 27.5296C30.3658 25.8888 30.1594 23.5548 28.4606 22.1821C26.7619 20.8094 24.5679 21.2023 23.235 22.7173Z",
    stroke: "#278DEC",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewCarePlan);
export default __webpack_public_path__ + "static/media/viewCarePlan.7429acc17db47b4d461c2d5fcbbc19ca.svg";
export { ForwardRef as ReactComponent };